import { useEffect, useState } from "react";
import CabecalhoAdmin from "../../componentes/CabecalhoAdmin";
import MenuLateral from "../../componentes/MenuLateral";
import ErroSpan from "../../componentes/ErroSpan";
import GraficoBarras from "./GraficoBarras";
import { AreaGrafico, AreaSuperior, FiltrarData, Inline2, InputMes, OpcoesFiltragem, SecaoAdmin, SecaoPrincipal } from "./AdminStyled";
import { IoMdRefresh } from "react-icons/io";
import { ticketsRelatorios } from "../../servicos/ticketsServices";
import { TabelaTotais } from "./TabelaTotais";
import { TabelaPorDia } from "./TabelaPorDia";
import { TabelaPorGuia } from "./TabelaPorGuia";

export default function Admin() {
    const [filtros, setFiltros] = useState({
        dataInicial: new Date (new Date().getTime() - 60 * 60 * 24 * 7 * 1000).toISOString().split("T")[0],
        dataFinal: new Date().toISOString().split("T")[0]
    });
    const [datas, setDatas] = useState({ 
        dataInicial: new Date (new Date().getTime() - 60*60*24*7*1000).toISOString().split("T")[0], 
        dataFinal: new Date().toISOString().split("T")[0] 
    });
    const [carregando, setCarregando] = useState(true);
    const [totais, setTotais] = useState(null);
    const [dadosRelatorio, setDadosRelatorio] = useState(null);
    const [totaisPorDia, setTotaisPorDia] = useState(null);
    const [totaisPorGuia, setTotaisPorGuia] = useState(null);

    useEffect(() => {
        ticketsRelatorios(filtros.dataInicial, filtros.dataFinal).then( resposta => {
            setDadosRelatorio({
                labels: resposta.porHora.horarios,
                datasets: [
                    {
                        label: "Ingressos por horário",
                        data: resposta.porHora.quantidade,
                        backgroundColor: 'rgba(99, 141, 255, 0.589)'
                    }
                ]
            });
            setTotaisPorDia(resposta.porDia);
            setTotaisPorGuia(resposta.porGuia);
            setTotais(resposta.totais);
            setCarregando(false);
        });
    }, [filtros]);

    function aplicarFiltros() {
        setCarregando(true);
        setFiltros(datas);
    }

    return (
        <SecaoAdmin>
            <MenuLateral />
            <SecaoPrincipal>
                {CabecalhoAdmin("Administração Tour Nugali")}
                {carregando && <ErroSpan>Carregando...</ErroSpan>}
                <AreaSuperior>
                    <OpcoesFiltragem>
                        <FiltrarData $marginTop="1px">
                            <label>Data inicial</label>
                            <InputMes type="date" defaultValue={datas.dataInicial} onChange={event => setDatas({...datas, dataInicial: event.target.value})}/>
                        </FiltrarData>
                        <FiltrarData $marginTop="1px">
                            <label>Data final</label>
                            <InputMes type="date" defaultValue={datas.dataFinal} onChange={event => setDatas({...datas, dataFinal: event.target.value})}/>
                        </FiltrarData>
                        <IoMdRefresh className="Icone" onClick={() => aplicarFiltros()}/>
                    </OpcoesFiltragem>
                </AreaSuperior>
                <Inline2>
                    <AreaGrafico $margem="30px 10px 30px 40px" $largura="60%"> {(dadosRelatorio && GraficoBarras("Relatório", dadosRelatorio)) || <p>Carregando</p>} </AreaGrafico>
                    <AreaGrafico $margem="50px 40px 30px 10px" $largura="40%">{(totais && TabelaTotais(totais)) || <p>Carregando</p>}</AreaGrafico>
                </Inline2>
                {totaisPorDia && TabelaPorDia(totaisPorDia)}
                {totaisPorGuia && TabelaPorGuia(totaisPorGuia)}
            </SecaoPrincipal>
        </SecaoAdmin>
    )
}